<template>
  <div>
    <div
      ref="bag"
      :class="'expansion-bag' + (expanded ? expanded : '')"
    >
      <slot />
    </div>
    <a
      ref="toggleBtn"
      href="#"
      @click.prevent="toggle()"
    >{{ expanded ? $t('pages.public-offers.filters.expansion-bag.show-less') : $t('pages.public-offers.filters.expansion-bag.show-more') }}</a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        expanded: false,
      };
    },
    mounted() {
      if (this.$refs.bag.clientHeight < 200) {
          this.$refs.toggleBtn.remove();
      }
    },
    methods: {
      toggle() {
        this.expanded = !this.expanded;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .expansion-bag {
    transition: height 1s;
    max-height: 200px;
    overflow-y: hidden;

    .expanded {
      max-height: unset;
    }
  }
</style>